<template>
  <a-card :title="title">
    <search-page-view
      :col="3"
      ref="tableList"
      :itemNames="['search-name','add-button']"
      :query-params="queryParams"
      :request-promise="getRequestPromise"
      :enable-search="false"
      :columns="getColumns()"
      rightButton="rightButton"
    >
      <a-form-item slot="search-name" label="姓名/手机号" v-bind="searchItemLayout">
        <a-input placeholder="姓名/手机号" v-model="queryParams.searchWord"></a-input>
      </a-form-item>
      <a-form-item slot="add-button">
        <a-button type="primary" style="margin-left: 10px" @click="onSearch">查询</a-button>
        <a-button style="margin-left: 10px" @click="addMember">添加核销员</a-button>
      </a-form-item>
      <a-form-item slot="rightButton">
        <div style="width: 100% ;display: inline-block;" @click="onGroupingSettingEvent">
          <span style="float:right;">核销分组<a style="margin-left: 6px">设置</a></span>
        </div>
      </a-form-item>
      <template slot="action" slot-scope="rowItem">
        <a style="margin-right:10px;" @click="associatedGrouping(rowItem.record)">关联分组</a>
        <a style="margin-right:10px;" @click="setupAdministrator(rowItem.record.id,2)" v-if="rowItem.record.role == 1">设为管理员</a>
        <a style="margin-right:10px;" @click="setupAdministrator(rowItem.record.id,1)" v-if="rowItem.record.role == 2">撤销管理员</a>
        <a-popconfirm
          title="确认移出吗?"
          @confirm="toRemove(rowItem.record.id)">
          <a>移出</a>
        </a-popconfirm>
      </template>
    </search-page-view>
    <a-modal title="绑定账号" :visible="visible" :width="670" @cancel="visible = false" :footer="null">
      <div style="margin-bottom: 20px">
        温馨提示：核销员仅能从分销员账号中选取并绑定，可在多个核销设置中指定
      </div>
      <a-form layout="inline">
        <a-form-item label="搜索名称">
          <a-input style="width: 200px;" v-model="queryMemberParams.searchWord"
                   placeholder="搜索手机号、真实姓名"></a-input>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
        </a-form-item>
      </a-form>
      <custom-page-table
        ref="table"
        :queryParams="queryMemberParams"
        :columns="getMemberColumns()"
        :requestPromise="loadPromise"
      >
        <span slot="index" slot-scope="rowItem">
            {{ rowItem.index + 1 }}
          </span>
        <span slot="action" slot-scope="rowItem">
            <a @click="bindMember(rowItem.record.staffId)">绑定</a>
          </span>
      </custom-page-table>
    </a-modal>
    <selected-product-dialog
      :show="showSelectedDialog"
      ref="pageDialogList"
      :query-params="selectedQueryParams"
      :requestPromise="loadGroupPromise"
      :enableSearch="false"
      @close="showSelectedDialog=false"
      :columns="getGroupColumns()"
    >
      <template slot="action" slot-scope="rowItem">
        <a v-if="rowItem.record.status==1" class="font-color" @click="updateGroup(0)">取消关联</a>
        <a v-else @click="updateGroup(rowItem.record.groupId)">关联</a>
      </template>
    </selected-product-dialog>
  </a-card>
</template>

<script>
import searchForm from '@/utils/mixins/searchFormMixins'
import SelectedProductDialog from '@/customComponents/SelectedProductDialog/SelectedProductDialog'

export default {
  name: 'VerificationSetting',
  mixins: [searchForm],
  components: {
    SelectedProductDialog
  },
  data() {
    return {
      visible: false,
      showGroupDialogCount: 0,
      showSelectedDialog: false,
      selectedVerifierId: '',
      queryParams: {},
      queryMemberParams: {},
      selectedQueryParams: {},
      title: this.$route.query.proName + ' >' + ' 核销设置',
      proName: this.$route.query.proName,
      couponId: this.$route.query.proId,
      loadPromise: params => this.getProListPromise(params)
    }
  },
  mounted() {
  },
  methods: {
    loadGroupPromise(params) {
      const url = 'couponVerifierGroup/getVerifierGroupPage'
      return this.getHttpServices().getCouponService().post(url, params)
    },
    getProListPromise(params) {
      params.couponId = this.couponId
      return this.getHttpServices().getCouponService().post('couponVerifier/getCouponVerifierAbleBindStaffList', params)
    },
    getRequestPromise(params) {
      params.couponId = this.couponId
      return this.getHttpServices().getCouponService().post('couponVerifier/getList', params)
    },
    onSearch() {
      this.$refs.tableList.refresh(true)
    },
    addMember() {
      this.visible = true
      this.$nextTick(function() {
        this.$refs.table.refresh(true)
      })
    },
    bindMember(id) {
      this.getHttpServices().getCouponService()
        .post('couponVerifier/bindCouponVerifier', {
          couponId: this.couponId,
          staffId: id
        })
        .then(res => {
          this.$message.success('绑定成功')
          this.$refs.tableList.refresh(true)
          this.visible = false
        }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
        this.visible = true

      })
    },
    associatedGrouping(item) {
      this.selectedVerifierId = item.id
      this.selectedQueryParams = {
        couponId: this.getPageParams().couponId,
        verifierId: item.id
      }
      this.$nextTick(() => {
        this.showSelectedDialog = true
        if (this.showGroupDialogCount > 0) {
          this.$refs.pageDialogList.refresh(true)
        }
        this.showGroupDialogCount++
      })
    },
    onGroupingSettingEvent() {
      let pageParams = this.getPageParams()
      const q = { proName: pageParams.proName, couponId: pageParams.couponId }
      this.openNewPage('GroupingSetting', q)
    },
    setupAdministrator(id, role) {
      this.getHttpServices().getCouponService()
        .post('couponVerifier/setCouponVerifierRole', {
          couponVerifierId: id,
          role: role
        })
        .then(res => {
          this.$message.success('设置成功')
          this.$refs.tableList.refresh(true)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    toRemove(id) {
      this.getHttpServices().getCouponService()
        .post('couponVerifier/removeCouponVerifier', { couponVerifierId: id })
        .then(res => {
          this.$message.success('移出成功')
          this.$refs.tableList.refresh(true)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getColumns() {
      return [
        {
          title: 'ID',
          dataIndex: 'id'
        },
        {
          title: '姓名',
          dataIndex: 'verifierName'
        },
        {
          title: '手机号',
          dataIndex: 'verifierMobile'
        },
        {
          title: '所属分组',
          dataIndex: 'groupName'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '240px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    getMemberColumns() {
      return [
        {
          title: '序号',
          dataIndex: 'index',
          scopedSlots: { customRender: 'index' }

        },
        {
          title: '姓名',
          dataIndex: 'name'
        },
        {
          title: '手机号',
          dataIndex: 'mobile'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    updateGroup(groupId) {
      const url = `couponVerifierGroup/relevanceVerifierGroup`
      const params = {
        groupId: groupId,
        verifierId: this.selectedVerifierId
      }
      this.getHttpServices().getCouponService().post(url, params)
        .then(res => {
          let tips = groupId > 0 ? '关联成功' : '取消关联成功'
          this.$message.success(tips)
          this.showSelectedDialog = false
          this.$refs.tableList.refresh(false)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getGroupColumns() {
      return [
        {
          title: 'ID',
          dataIndex: 'groupId'
        },
        {
          title: '分组名称',
          dataIndex: 'groupName'
        },
        {
          title: '备注',
          dataIndex: 'remarks'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '120px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  }
}
</script>

<style scoped>

</style>